<template lang="pug">
	main
		Controls
		CellWrapper
</template>

<script>
	import CellWrapper from '~/components/CellWrapper';
	import Controls from '~/components/Controls';

	export default {
		name: 'DefaultLayout',
		components: { CellWrapper, Controls }
	};
</script>
